"use client";

import React from "react";
import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [];
export default function NewMusic() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section data-section-id="223034" id="new-music" className="py-20 md:py-32 bg-background text-foreground overflow-hidden relative">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary/5 via-transparent to-transparent opacity-30" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 md:mb-20 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 text-foreground tracking-wider uppercase">Current And Upcoming Releases</h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans leading-relaxed">Explore the latest releases from Heavens Horizon Records. From futuristic EDM beats to captivating Country Pop melodies, discover music that pushes the boundaries of creativity and expands the horizon of sound.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[150px] md:auto-rows-[250px] grid-flow-dense">
          {galleryImages.map((img, i) => <GalleryItem key={img.id} img={img} index={i} />)}
        </div>
      </div>
    </section>;
}
function GalleryItem({
  img,
  index
}: {
  img: any;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <Dialog>
      <DialogTrigger asChild data-index={index}>
        <div ref={ref} className={`relative overflow-hidden rounded-xl cursor-pointer group ${img.className} transition-all duration-700 border border-white/5 backdrop-blur-sm shadow-lg ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`} style={{
        transitionDelay: `${index * 100}ms`
      }}>
          <img src={img.src} alt={img.alt} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110 grayscale-[20%] group-hover:grayscale-0" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-br from-primary/40 to-secondary/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-2">
            <div className="bg-background/80 backdrop-blur-md p-3 rounded-lg border border-primary/50">
              <ZoomIn className="text-primary size-8" />
            </div>
            <span className="font-default text-xs font-bold tracking-widest uppercase text-white drop-shadow-lg">Quick Play</span>
          </div>
        </div>
      </DialogTrigger>
      <DialogContent className="max-w-5xl w-[95vw] p-1 md:p-2 bg-background/95 backdrop-blur-xl border-border shadow-4xl">
        <DialogTitle className="sr-only">{img.alt}</DialogTitle>
        <div className="relative w-full h-full max-h-[85vh] rounded-lg overflow-hidden bg-card flex items-center justify-center border border-white/10">
          <img src={img.src} alt={img.alt} className="w-full h-full max-h-[85vh] object-contain" />
          {}
          <div className="absolute bottom-4 left-4 right-4 p-4 bg-black/60 backdrop-blur-md rounded-lg border border-white/10">
             <p className="font-default text-sm text-white text-center">Streaming Preview Available on Official Release</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>;
}